import React from "react";
import { isViewVisible } from "../../../utils/ViewSettings";
import SettingsView from "./components/SettingsView";

export const SettingsPage = (props) => {
  let _view = typeof props.view === "undefined" || props.view === null ? "index" : props.view;
  let indexView = "settings";
  return (
    <>
      {_view === "settings" && isViewVisible("settings") && (
        <SettingsView
          name={"settings"}
          dispatch={props.dispatch}
          params={props.params}
          returnPath={props.returnPath}
        />
      )}
    </>
  );
};
